// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"fea606c7","52":"e7d2f44d","185":"3d43b0cb","264":"91bbe9ec","453":"1936ba5e","467":"7649961d","470":"0a22883d","575":"54b60c41","615":"2dba8230","624":"e8e9720c","641":"34f8ce3b","655":"78a4a01b","675":"ca0d7f4d","818":"d51f5316","907":"e0c7ccf8","961":"2cba7949"}[chunkId] + ".chunk.js";
};